

import React, { useState } from 'react';
import { TableCell, TableRow, Typography } from '@mui/material';
import { Image, Space, Dropdown, Menu, Modal } from "antd";
import { useSelector } from "react-redux";
import customStyles from "../../../../../assets/styles/customStyles";
import { productGroupHead } from "../../../../../config/constant";
import { Link, NavLink } from "react-router-dom";
import clsx from "clsx";
import settings from '../../../../../config/settings';
import { toast } from 'react-toastify';
import ElipsisIcon from "../../../../../assets/images/icon_actions/Elipsis.svg";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import { checkCRUDPermission, getColumnWidth, idNamingConversion } from "../../../../../helpers/utilities";
import SearchText from '../../../../Shared/components/SearchText';
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { postRequest } from '../../../../../helpers/axiosClient';


export const ListTable = (props) => {
    const { onRequestSort, sortOrder, sortBy,
        details, loadMore, onView, handleOpen,
        loadMoreContent, loadMoreTask, search,
        onEdit, onDelete, roleManagement } = props;
    const { unitMesurementdetails } = useSelector(state => state.productSetupReducer);
    const { parameterDetails } = useSelector(state => state.homeReducer);

    const [defaultUnits, setDefaultUnits] = useState({});
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleDefaultOpen = (visible, groupId = '') => {
        setVisible(visible);
        setDefaultUnits(groupId ? { 'groupId': groupId } : {});
    };

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const handleDefaultUnitSubmit = async () => {
        setLoading(true);
        toast.dismiss();
        console.log(defaultUnits);
        try {
            await postRequest(`${settings.ROOT_URL}/assign-units`,
                {
                    productGroupId: defaultUnits?.groupId,
                    salesUnitId: defaultUnits?.salesUnitId || undefined,        // optional
                    purchaseUnitId: defaultUnits?.purchaseUnitId || undefined,  // optional
                }
            );

            setLoading(false);
            toast('Assign Default Units Updated Successfully');
            handleDefaultOpen(false);
        } catch (error) {
            let message = error?.response?.data?.error?.message || 'Assign Default Units Error';
            console.error('Error:', error?.response?.data?.error?.message);
            setLoading(false);
            toast.error(message);
        }
    };

    const classes = customStyles();
    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                loadMoreTask={loadMoreTask}
                heads={productGroupHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                width={true}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={8}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                            <TableRow
                                                key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell style={{ width: getColumnWidth(productGroupHead, 0) }}>
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Product Group', 'view', 'Product') ?
                                                            <NavLink id={idNamingConversion('View_' + data.id, 'productGroup', 'Link')} style={{ width: getColumnWidth(productGroupHead, 0) }} to={"#"} onClick={() => onView(data)} className={clsx(classes.color, classes.wordBreak, classes.positionRelative, classes.PaddingRight50, classes.disBlock, classes.bold)}>{data?.name || ''}</NavLink>
                                                            : <span style={{ width: getColumnWidth(productGroupHead, 0) }}>{data.name || '---'}</span>
                                                    }
                                                </TableCell>
                                                <TableCell style={{ width: getColumnWidth(productGroupHead, 1) }}><span style={{ width: getColumnWidth(productGroupHead, 1) }}>{data?.description ? data?.description : '---'}</span></TableCell>

                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Product Group', 'view', 'Product') &&
                                                            <NavLink id={idNamingConversion('View_' + data.id, 'productGroup', 'Icon')} to={"#"} onClick={() => onView(data)}>
                                                                <Image src={ViewIcon} preview={false} />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Product Group', 'edit', 'Product') &&
                                                            <NavLink id={idNamingConversion('Edit_' + data.id, 'productGroup', 'Icon')} to={"#"} onClick={() => onEdit(data)}>
                                                                <Image src={EditIcon} preview={false} />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Product Group', 'deletable', 'Product') &&
                                                            <NavLink id={idNamingConversion('Delete_' + data.id, 'productGroup', 'Icon')} to={"#"} onClick={() => onDelete(data)} >
                                                                <Image src={DeleteIcon} preview={false} />
                                                            </NavLink>
                                                        }
                                                        <Dropdown
                                                            trigger={['click']}
                                                            placement={'bottomRight'}
                                                            overlay={
                                                                <Menu className={clsx(classes.groupMenu)}>
                                                                    <Menu.Item className={clsx(classes.accordionSubmenuArrow)}></Menu.Item>
                                                                    <Menu.Item><Link id={idNamingConversion('View Product_' + data.id, 'productGroup', 'Link')} to={`/product/product/my-products/${data.id}`}>View Product</Link></Menu.Item>
                                                                    {
                                                                        parameterDetails?.defaultUnits ? <Menu.Item><NavLink onClick={() => handleDefaultOpen(true, data?.id)} id={idNamingConversion('Assign units_' + data.id, 'productGroup', 'Link')} to={`#`}>Assign units</NavLink></Menu.Item> : null
                                                                    }
                                                                </Menu>
                                                            }>
                                                            <Image
                                                                id={idNamingConversion('Elipsis_' + data.id, 'productGroup', 'Icon')}
                                                                src={ElipsisIcon}
                                                                preview={false}
                                                            />
                                                        </Dropdown>
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={8}>
                                                    {
                                                        search !== '' ? <SearchText /> : <>
                                                            <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start by grouping your product'}</p>
                                                            <div className={classes.margin20t}>
                                                                <NavLink
                                                                    style={{ display: "inline-block" }}
                                                                    to={`#`}
                                                                    onClick={() => handleOpen()}
                                                                    className={clsx(classes.modalBtn)}>Create Product Group
                                                                </NavLink>
                                                            </div></>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
            {console.log((defaultUnits?.purchaseUnitId || !defaultUnits?.salesUnitId))}
            <Modal
                title={'Default Units'}
                width={650}
                open={visible}
                onOk={() => handleDefaultOpen(false)}
                onCancel={() => handleDefaultOpen(false)}
                footer={[
                    <NavLink
                        to={'#'}
                        onClick={() => handleDefaultUnitSubmit()}
                        className={clsx(classes.modalBtn, classes.bold, classes.textAlignLeft, { [classes.disabled]: (!defaultUnits?.purchaseUnitId && !defaultUnits?.salesUnitId) }, { [classes.loading]: loading })}
                    >OK</NavLink>
                ]}
                className={clsx(classes.commonPopup, classes.commonPopupText, classes.removeUnderline, classes.deletePopup)}>
                <Typography variant={'subtitle1'} className={clsx(classes.fonSize14, classes.textAlignLeft)} style={{ color: "#1c314c" }}>Please choose the Default Sales & Purchase Units that suits your business and click OK</Typography>
                <Space direction="horizontal" align="center" className={classes.modalPaper} style={{ width: "100%", margin: "0" }}>
                    <AutoCompleteComponent
                        name={["Default Purchase Unit "]}
                        heads={[{ 'key': 'name', 'name': 'Unit' },
                        { 'key': 'description', 'name': 'Description' }]}
                        details={unitMesurementdetails}
                        catalogueModal={true}
                        parentValue={customObject(unitMesurementdetails, defaultUnits?.purchaseUnitId)}
                        position={"bottom"}
                        customClasses={classes.margin20t}
                        onChange={(data) => setDefaultUnits({
                            ...defaultUnits, 'purchaseUnitId': data?.id
                        })}
                    />
                    <AutoCompleteComponent
                        name={["Default Sales Unit "]}
                        heads={[{ 'key': 'name', 'name': 'Unit' },
                        { 'key': 'description', 'name': 'Description' }]}
                        details={unitMesurementdetails}
                        catalogueModal={true}
                        parentValue={customObject(unitMesurementdetails, defaultUnits?.salesUnitId)}
                        position={"bottom"}
                        customClasses={classes.margin20t}
                        onChange={(data) => setDefaultUnits({
                            ...defaultUnits, 'salesUnitId': data?.id
                        })}
                    />
                </Space>
            </Modal>
        </>
    )
}